import { Dimensions } from 'react-native';
import Styles from './styles';
/**
 * 获取按钮大小
 * @param props
 */
export function getButtonSizeStyle(props) {
    const { size = 'medium', needScale = false } = props;
    const buttonSize = Styles.getButtonSize(needScale);
    return buttonSize[size] || {};
}
/**
 * 获取按钮类型
 * @param props
 */
export function getButtonTypeStyle(props) {
    const { type = 'normal' } = props;
    const { buttonType } = Styles;
    return buttonType[type] || {};
}
/**
 * 按钮形状样式
 * @param props
 */
export function getButtonShapeStyle(props) {
    const { shape = 'capsule', size = 'medium', needScale = false } = props;
    const buttonShapeType = Styles.getButtonShape(needScale);
    const buttonShape = buttonShapeType[shape];
    return buttonShape[size] || {};
}
/**
 * 计算按钮outline样式
 * @param props
 */
export function getButtonOutlineStyle(props) {
    const { outline = false, type = 'normal' } = props;
    // 是否需要展示outline样式
    if (outline) {
        const { buttonOutline } = Styles;
        // 配置是否支持改类型的outline样式
        if (buttonOutline[type]) {
            const { borderColor, backgroundColor, fontColor } = buttonOutline[type];
            return {
                wrapper: {
                    borderColor,
                    backgroundColor
                },
                icon: {
                    color: fontColor
                },
                text: {
                    color: fontColor
                }
            };
        }
    }
    return {
        wrapper: {},
        icon: {},
        text: {}
    };
}
/**
 * 计算按钮disabled样式
 * @param props
 */
export function getButtonDisableStyle(props) {
    const { disabled = false, outline } = props;
    if (disabled) {
        return outline ? Styles.buttonOutlineDisable : Styles.buttonDisabled;
    }
    return {
        wrapper: {},
        icon: {},
        text: {}
    };
}
// 对象是否为空
const isValidObject = (obj) => obj && Object.keys(obj).length;
/**
 * 获取按钮容器自定义样式
 * @param styles
 * @param props
 */
export function getWrapperCustomStyle(styles, props) {
    const { customStyle = {}, type, disabled, shape } = props;
    if (isValidObject(customStyle)) {
        const { width, borderColor, borderWidth, backgroundColor, paddingHorizontal, paddingLeft, paddingRight } = customStyle;
        // 设置按钮宽度
        if (width !== undefined) {
            styles.width = width;
        }
        // 设置按钮边框宽度
        if (borderWidth !== undefined) {
            styles.borderWidth = borderWidth;
        }
        // 按钮背景色 - 只有非透明&未禁止时才会设置背景色
        if (backgroundColor && type !== 'ghost' && !disabled) {
            styles.backgroundColor = backgroundColor;
        }
        // 设置边框颜色 - 禁止按钮不允许设置边线
        if (borderColor && !disabled) {
            styles.borderColor = borderColor;
        }
        // 设置按钮左右边距
        if (paddingHorizontal !== undefined) {
            styles.paddingHorizontal = paddingHorizontal;
        }
        // 设置按钮左边距
        if (paddingLeft !== undefined) {
            styles.paddingLeft = paddingLeft;
        }
        // 设置按钮右边距
        if (paddingRight !== undefined) {
            styles.paddingRight = paddingRight;
        }
    }
    // 如果是圆形的话，强制设置宽高相等
    if (shape === 'circle') {
        styles.width = styles.height;
        styles.minWidth = styles.height;
    }
    return styles;
}
/**
 * 获取按钮文本自定义样式
 * @param styles
 * @param props
 */
export function getTextCustomStyle(styles, props) {
    const { customStyle = {}, disabled } = props;
    if (isValidObject(customStyle)) {
        // 设置字体粗细
        if (customStyle.fontWeight) {
            styles.fontWeight = customStyle.fontWeight;
        }
        // 设置字体颜色 - 禁止按钮不允许设置颜色
        if (!disabled && customStyle.color) {
            styles.color = customStyle.color;
        }
    }
    return styles;
}
/**
 * 过滤组件props属性
 * @param props
 * @param excludesProps
 */
export function filterProps(props, excludesProps = []) {
    const buttonProps = {
        text: ''
    };
    Object.keys(props).forEach((key) => {
        if (!excludesProps.includes(key)) {
            buttonProps[key] = props[key];
        }
    });
    return buttonProps;
}
/**
 * 计算按钮样式
 * @param props
 */
export function getButtonStyles(props) {
    // 按钮大小
    const { wrapper: sizeWrapper, icon: sizeIcon, text: sizeText } = getButtonSizeStyle(props);
    // 按钮类型
    const { wrapper: typeWrapper, icon: typeIcon, text: typeText } = getButtonTypeStyle(props);
    // 按钮形状
    const shapeStyle = getButtonShapeStyle(props);
    // outline样式
    const { wrapper: outlineWrapper, icon: outlineIcon, text: outlineText } = getButtonOutlineStyle(props);
    // 是否disable
    const { wrapper: disWrapper, icon: disIcon, text: disText } = getButtonDisableStyle(props);
    // 按钮容器样式
    const wrapperStyle = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, typeWrapper), sizeWrapper), shapeStyle), outlineWrapper), disWrapper), { 
        // 设置按钮最大宽度
        maxWidth: Dimensions.get('window').width - 48 });
    // icon样式
    const iconStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, typeIcon), sizeIcon), outlineIcon), disIcon);
    // 文字样式
    const textStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, typeText), sizeText), outlineText), disText);
    return {
        wrapper: getWrapperCustomStyle(wrapperStyle, props),
        icon: getTextCustomStyle(iconStyle, props),
        text: getTextCustomStyle(textStyle, props)
    };
}
